// API configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';

// WebSocket configuration
export const WS_BASE_URL = import.meta.env.VITE_WS_URL || 'ws://localhost:8000';

// Webhook configuration
export const WEBHOOK_BASE_URL = import.meta.env.VITE_WEBHOOK_BASE_URL || 
                                import.meta.env.VITE_API_URL?.replace('/api/v1', '') || 
                                (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:8000');

// Other config settings can be added here
export const MAX_RETRY_ATTEMPTS = 3;
export const REQUEST_TIMEOUT = 30000; // 30 seconds

// Export default config object
const config = {
  apiBaseUrl: API_BASE_URL,
  wsBaseUrl: WS_BASE_URL,
  webhookBaseUrl: WEBHOOK_BASE_URL,
  maxRetryAttempts: MAX_RETRY_ATTEMPTS,
  requestTimeout: REQUEST_TIMEOUT,
};

export default config; 